@import './pk-toast.variables';

:host {
  @apply fixed bottom-0 left-0 right-0 mx-m my-0 flex flex-col overflow-hidden;
  @apply sm:mx-auto sm:my-0 sm:w-[--toast--width];
}
